module.exports = __webpack_public_path__ + "static/joe-gebbia-86c9db674474e0c5bf54a2e681cce8c4.jpg";